<template>
	<div>
		<!-- 暂未配置支付账号 -->
		<div class="pay-warp no-box" v-if="info.is_open == 0">
			<div>
				<div class="title">暂未配置支付账号</div>
				 <div class="add-box">
					<img src="../../assets/img/pay/wechat.png" alt="" class="wechat-icon">
					<div class="desc">社群拍档作为微信支付服务商，代商户申请微信支付账号。</div>
					<el-button class="add-btn" type="primary" size="medium" @click="addWechat()">配置微信支付商户号</el-button>
				 </div>
			</div>
		</div>
		
		<!-- 已配置商户号信息 -->
		<div class="pay-warp" v-else-if="info.is_open == 1">
			<!-- 商户号状态 -->
			<div class="title-box">
				<!-- 状态 -->
				<div class="status-box">
					<img v-if="info.mch_info.status.icon == 'success'" src="../../assets/img/public/success.png" alt="" class="status-icon">
					<img v-else-if="info.mch_info.status.icon == 'error'" src="../../assets/img/public/error.png" alt="" class="status-icon">
					<img v-else-if="info.mch_info.status.icon == 'warning'" src="../../assets/img/public/warning.png" alt="" class="status-icon">
					<img v-else src="../../assets/img/public/timing.png" alt="" class="status-icon">
					{{info.mch_info.status.txt}}
				</div>
				<!-- 错误信息 -->
				<div class="err-msg" v-if="info.mch_info.status.err_msg.length > 0">
					<div v-for="(value,index) in info.mch_info.status.err_msg">{{value}}</div>
				</div>
			</div>
			
			<div class="gp-layer-body">
				<!-- 商户号信息 -->
				<div class="gp-row gp-row-center padding-bottom-0">
					<div class="gp-row-label"></div>
					<div class="gp-row-title">商户号信息</div>
				</div>
				<div class="gp-information">
					<div class="gp-item">
						<div class="gp-option-title">商户号类型</div>
						<div class="gp-option-value">微信支付</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">主体名称</div>
						<div class="gp-option-value">{{info.mch_info.merchant_name}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">支付商户号</div>
						<div class="gp-option-value">{{info.mch_info.mchid}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">提交时间</div>
						<div class="gp-option-value">{{info.mch_info.create_time}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">分账功能</div>
						<div class="gp-option-value">{{info.mch_info.profit_share}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">更新时间</div>
						<div class="gp-option-value">{{info.mch_info.update_time}}</div>
					</div>
				</div>

				<!-- 结算银行账户 -->
				<div class="gp-row gp-row-center">
					<div class="gp-row-label"></div>
					<div class="gp-row-title">结算银行账户</div>
				</div>
				<div>
					<div class="gp-item">
						<div class="gp-option-title">开户名称</div>
						<div class="gp-option-value">{{info.bank_info.account_name}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">银行账号</div>
						<div class="gp-option-value">{{info.bank_info.account_number}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">开户银行</div>
						<div class="gp-option-value">{{info.bank_info.account_bank}}</div>
					</div>
					<div class="gp-item">
						<div class="gp-option-title">开户行全称</div>
						<div class="gp-option-value">{{info.bank_info.bank_name}}</div>
					</div>
				</div>
			</div>
			<!-- 如果被驳回，则可以再次编辑并提交 -->
			<el-button class="edit-btn" type="primary" size="medium" @click="addWechat(1)" v-if="info.mch_info.status.icon == 'error'">修改信息</el-button>
		</div>
	</div>
</template>

<script>
	import {
		getInfo
	} from '../../api/pay';
	export default {
		data() {
			return {
				info: {
					is_open: -1
				}
			}
		},
		components: {
		},
		created() {
			this.get_info();
		},
		methods: {
			get_info(){
				getInfo({
				}).then(res => {
					this.info = res.data
				})
			},
			addWechat(edit = 0) {
				this.$router.push({
					path: '/shop/pay-wechat',
					query: {edit: edit}
				});
			}
		}
	}
</script>

<style scoped>
	
	.pay-warp{
		font-family: PingFang-SC-Medium, PingFang-SC;
		background: #FFFFFF;
		min-height: 670px;
		height: 86vh;
	}
	
	/* 暂未配置支付账号 */
	.no-box{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.no-box .title{
		font-size: 48px;
		color: #333333;
	}
	/* - 添加微信商户号 */
	.no-box .add-box{
		width: 375px;
		height: 348px;
		padding: 60px;
		box-sizing: border-box;
	}
	.no-box .add-box .wechat-icon{
		width: 74px;
		height: 68px;
		display: block;
		margin: 0 auto;
	}
	.no-box .add-box .desc{
		width: 245px;
		font-size: 14px;
		color: #333333;
		line-height: 20px;
		text-align: center;
		margin: 30px auto 50px auto;
	}
	.no-box .add-box .add-btn{
		display: block;
		margin: 0 auto;
	}
	
	/* 已配置商户信息 */
	.has-box{
		height: 80vh;
	}
	/* - 商户状态 */
	.title-box{
		font-size: 21px;
		color: #333333;
		margin: 0 20px;
		padding: 16px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.title-box .status-box{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.title-box .status-icon{
		width: 40px;
		height: 40px;
		margin-right: 21px;
	}
	/* - 商户失败时错误信息 */
	.title-box .err-msg{
		font-size: 12px;
		color: #F56C6C;
		line-height: 17px;
		text-align: center;
		margin-top: 20px;
	}
	
	.gp-row {
		width: 100%;
		padding: 30px 0 10px 0;
		display: flex;
		align-items: flex-start;
	}
	/* - 标题 */
	.gp-row-center {
		align-items: center;
	}
	.gp-row-label {
		width: 3px;
		height: 25px;
		margin-right: 15px;
		background: #409EFF;
	}
	.gp-row-title {
		font-size: 18px;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}
	.gp-row-value {
		width: 200px;
	}
	
	/* - 每项信息设置 */
	.gp-item{
		display: flex;
		flex-wrap: wrap;
		font-size: 14px;
		margin-top: 20px;
	}
	.gp-item .gp-option-title{
		width: 140px;
		text-align: right;
		color: #999999;
	}
	.gp-item .gp-option-value{
		margin-left: 30px;
		color: #333333;
		line-height: 22px;
	}
	/* - 商户号信息-特殊配置 */
	.gp-information{
		display: flex;
		flex-wrap: wrap;
	}
	.gp-information .gp-item:odd{
		width: 40%;
	}
	.gp-information .gp-item:even{
		width: 60%;
	}
	.gp-information .gp-item .gp-option-value{
		width: 300px;
	}
	/* - 修改信息按钮 */
	.edit-btn{
		margin: 48px 0 22px 50px;
	}
</style>
